// extracted by mini-css-extract-plugin
module.exports = {"actions":"Dashboard_actions__j3LU2","carousel":"Dashboard_carousel__CxtTu","slider":"Dashboard_slider__Zx5Qf","icon-touch-wrapper":"Dashboard_icon-touch-wrapper__zjN_g"};